import Text from "../../Components/Text"
import Icon from "../../Components/Icon"
import Button from "../../Components/Buttons/Button"
import { useNavigate } from "react-router-dom";
import TIcon from "../../Components/TIcon";
import Footer from "../../Components/Footer";
import { useModal } from "../../Components/Modal";
import AGB from "../../Components/AGB";
import DSE from "../../Components/DSE";
import Impressum from "../../Components/Impressum";
import CookieInfo from "../../Components/CookieInfo";
import { useEffect, useState, useRef } from "react";
import { WorkspaceFindForm } from "../../Form/WorkspaceFindForm";

const MainPage = () => {
    const navigate = useNavigate();
    const { openModal, ModalView, closeModal } = useModal()
    const [isCookie, setIsCookie] = useState(false)

    const restaurantRef = useRef(null);
    const productsRef = useRef(null);
    const promiseRef = useRef(null);
    const nullRef = useRef(null);

    useEffect(() => {
        const accepted = localStorage.getItem("cookiesAccepted");
        if (!accepted) {
            setIsCookie(true)
            openModal(<CookieInfo onAccept={acceptCookies} />);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        closeModal();
        setIsCookie(false)
    };

    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    const infoBox = (icon, title, content, ref) => {

        return (
            <div onClick={() => scrollToSection(ref)} className="rounded-md bg-gray-50 shadow-lg hover:shadow-lg border-2 border-gray-300 hover:border-blue-300 p-6 flex flex-col w-full">
                <div className="flex w-full gap-6 justify-center">
                    <TIcon name={icon} />
                    <Text type="title">{title}</Text>
                </div>

                <Text type="main" classNames="text-gray-600 mt-2">
                    {content}
                </Text>
            </div>
        )
    }

    const main = () => (
        <>
            <div className="flex flex-col w-full ">
                <div className="flex flex-col">
                    {/* Find Restaurants */}
                    <div ref={restaurantRef} className="border-b rounded p-6 text-center flex flex-col justify-center gap-4 w-full bg-orange-300">
                        <div className="w-full flex justify-center">
                            <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                                <Text type="webtitle">Finde leckeres Essen in deiner Nähe</Text>
                                <Text type="main" classNames="text-gray-700 mt-2">
                                    Entdecke Restaurants, Cafés und Foodtrucks in deiner Nähe und bestelle direkt über Snack2Go – einfach, schnell und ohne Anstehen!
                                </Text>
                            </div>
                        </div>

                        <div className="w-full flex justify-center">
                            <div className="flex flex-col w-full md:w-2/3 text-center">
                                <Button onClickAction={() => navigate("/search")} buttonColor="bg-white hover:bg-gray-200" classNames="shadow-lg">
                                    <Text type="buttontext" classNames={"hover:underline"}>Jetzt Restaurant suchen</Text>
                                </Button>
                            </div>
                        </div>

                    </div>

                    {/* Vorteile */}
                    <div ref={promiseRef} className="border-b rounded p-6 text-center bg-slate-100 flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitle">Unsere Versprechen</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Mit Snack2Go erlebst du den einfachsten Weg, Essen zu bestellen – direkt, schnell und bequem.
                            </Text>
                            <div className="flex flex-col gap-2 w-full mt-6">
                                <div className="flex flex-col md:flex-row gap-2 w-full mt-6 justify-center">
                                    {infoBox("reserved-line", "Direkt bestellen", "Wähle dein Lieblingsgericht aus und bestelle direkt beim Anbieter – ohne Umwege.", nullRef)}
                                    {infoBox("clock", "Kein Anstehen", "Spare Zeit: Bezahle direkt in der App und hole dein Essen stressfrei ab.", nullRef)}
                                    {infoBox("user", "Einfach & intuitiv", "Unsere App ist leicht verständlich – alle Restaurants, Menüs und Optionen auf einen Blick.", nullRef)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Produkte verwalten / Optional Hinweis auf Anbieter */}
                    <div className="border-b rounded p-6 text-center flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitle">Hungrig? Bestelle jetzt!</Text>
                            <Text type="main" classNames="text-gray-600 mt-1">
                                Wähle dein Lieblingsrestaurant, scrolle durch die Menüs und bestelle deine Mahlzeit bequem über die Snack2Go-App – frisches Essen, direkt zu dir.
                            </Text>
                        </div>
                    </div>

                    {/* Hinweis auf Cashier One */}
                    <div ref={productsRef} className="border-b rounded p-6 text-center bg-slate-100 flex justify-center">
                        <div className="flex flex-col py-24 w-full md:w-2/3 text-center">
                            <Text type="webtitle">Für Restaurant- & Café-Betreiber</Text>
                            <Text type="main" classNames="text-gray-600 mt-2">
                                Unsere Partner nutzen unsere **<a href='https://www.cashier-one.ch' target='_blank' rel='noopener noreferrer' className='text-orange-400 hover:text-orange-500 underline'>Cashier One</a>** Kassenapp, um Bestellungen effizient zu verwalten.
                                So stellen wir sicher, dass deine Vorbestellungen über Snack2Go reibungslos beim Anbieter ankommen.
                            </Text>
                            <Text type="main" classNames="text-gray-600 mt-2">
                                Möchtest du als Betreiber auch gelistet werden? Dann schau dir <a href='https://www.cashier-one.ch' target='_blank' rel='noopener noreferrer' className='text-orange-400 hover:text-orange-500 underline'>Cashier One</a> an und werde Teil des wachsenden Netzwerks.
                            </Text>
                        </div>
                    </div>

                    {footerContent()}
                </div>
            </div>
        </>
    )

    const footerContent = () => (
        <div className="flex flex-col text-center p-6 bg-gray-500 gap-4 w-full">
            <div className="flex justify-center items-center gap-6 w-full">
                {footerItemWrapper("Impressum", <Impressum />)}
                {footerItemWrapper("Datenschutzerklärung", <DSE />)}
                {footerItemWrapper("AGB", <AGB />)}
                <a
                    href="mailto:raycraftstudios.ch@gmail.com?subject=Cashier%20One%20Support"
                    className="text-white hover:underline"
                >
                    <Text classNames={"text-white hover:underline"}>Kontakt</Text>
                </a>
            </div>
            <Footer textColor="text-white" />
        </div>
    )

    const footerItemWrapper = (title, modalContent) => {
        return (<div onClick={() => { setIsCookie(false); openModal(modalContent) }}>
            <Text classNames={"text-white hover:underline"}>{title}</Text>
        </div>)
    }

    const refButton = (text, ref) => {
        return (
            <Button onClickAction={() => scrollToSection(ref)} buttonColor="transparent" borderStyle="">
                <Text type="buttontext" classNames={"hover:underline"}>{text}</Text>
            </Button>
        )
    }

    return (
        <div className="flex flex-col h-full w-full bg-white">
            {/* Navbar */}
            <div className="flex items-center justify-between p-3 border-b border-gray-200">
                <div className="flex items-center w-full gap-4">
                    <Icon iconName={"small_logo.png"} classNames="h-20" />
                </div>
                <div className="flex w-full justify-end gap-4">
                    <div className="hidden md:flex items-center gap-4">
                        {refButton("Restaurant Suchen", restaurantRef)}
                        {refButton("Verkäufer werden", promiseRef)}
                    </div>

                    <Button classNames="w-fit shadow-lg" buttonColor={"bg-orange-300 hover:bg-orange-700"} children={
                        <div className="flex flex-row justify-between items-center p-1 h-full w-full">
                            <TIcon name="user" />
                            <Text type="orderitem" classNames="w-full text-center">Anmelden</Text>
                        </div>

                    } onClickAction={() => navigate("/login")} />
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 h-full overflow-auto">
                <div className="w-full h-full flex flex-row">
                    {main()}
                </div>
                <ModalView classNames={isCookie ? "w-min h-min" : "w-min h-full"} />
            </div>
        </div>)
}
export default MainPage